import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

export const errorText = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg ?? JSON.stringify(e)).join(" ");
  return detail?.msg ?? String(detail);
};

export const getMe = async () => {
  try {
    return (await api.get("/auth/me")).data;
  } catch {
    try {
      return (await api.post("/auth/refresh")).data;
    } catch {
      return null;
    }
  }
};
